<div *ngIf="article">
  <div class="ui medium header">
    {{article.title}}
  </div>
  <div [innerHTML]="article.body" class="article-body"></div>
</div>
